import React, {useRef, useState, useEffect, useContext, startTransition} from "react";
import { isEmpty } from "../../helpers/utils";

import "./index.css";
import { votingApi } from '../../helpers/fetcher';
import { ACTIONS } from '../../store/Actions';
import { DataContext } from "../../store/GlobalState";
const CardBody = ({ phenomenon,  isTranslated, langForTransState }) => {
  const cardBodyRef = useRef()
  const cardBodyRef2 = useRef()

  const {
    state: { getTheWholeCardHtmlElms,  isAutoTrans },
    dispatch,
  } = useContext(DataContext);

  const [translations, settranslations] = useState(null)
  const [originalTitle, setoriginalTitle] = useState(() => cardBodyRef.current?.innerHTML)

  useEffect(() => {
    const fetcher = async () => {
      const res1 = await votingApi.translation("en", langForTransState, originalTitle)
      settranslations(() => {
        return {
          res1
        }
      })
      
    };
    !!isTranslated && !! originalTitle && fetcher();
    
  }, [ isTranslated, originalTitle, langForTransState])

  useEffect(() => {
    startTransition(() => {
      dispatch({
        type: ACTIONS.DATAFORTRANSLATIONCARDBODY,
      payload: {
        body: translations?.res1?.data,
      }
    })
    })
  }, [translations, dispatch])

  useEffect(() => {
    if (!!phenomenon?.body) {
      if (true) {
        if (!!cardBodyRef.current?.innerHTML && !cardBodyRef2.current) {
          cardBodyRef2.current = cardBodyRef.current?.innerHTML
        }
        !!cardBodyRef2.current && !originalTitle && setoriginalTitle(() => cardBodyRef2.current)

        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD2,
        //   payload:  true
        // })
      }
    }
  }, [isTranslated, phenomenon, dispatch, originalTitle])

  return phenomenon && !isEmpty(phenomenon) ? (
    <>
      {phenomenon?.body && !isTranslated && (
        <div
          ref={cardBodyRef}
          id="card-body"
          dangerouslySetInnerHTML={{ __html: phenomenon?.body }}
        ></div>
      )}
      {phenomenon?.body && !!isTranslated && (
        <div
          ref={cardBodyRef}
          id="card-body"
          dangerouslySetInnerHTML={{ __html: translations?.res1?.data }}
        ></div>
      )}
    </>
  ) : null;
};

export default CardBody;
